(function () {
  if (window.__mmPdp) return;
  window.__mmPdp = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var once = function (el, key) {
    if (el.dataset['mmInit' + key]) return false;
    el.dataset['mmInit' + key] = '1';
    return true;
  };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = (format || '${{amount}}').match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return (format || '${{amount}}').replace(placeholder, value);
  }

  /* ---------- accordions ---------- */
  function initAccordions(root) {
    $$('[data-mm-acc]', root).forEach(function (group) {
      if (!once(group, 'Acc')) return;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mm-acc-btn]');
        if (!btn || !group.contains(btn)) return;
        var item = btn.closest('[data-mm-acc-item]');
        var open = item.classList.contains('is-open');
        $$('[data-mm-acc-item]', group).forEach(function (other) {
          other.classList.remove('is-open');
          var b = $('[data-mm-acc-btn]', other);
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
        group.dispatchEvent(new CustomEvent('mm:acc-change', { bubbles: true }));
      });
    });
  }

  /* ---------- scroll-snap sliders (mobile gallery, community) ---------- */
  function initSliders(root) {
    $$('[data-mm-slider]', root).forEach(function (slider) {
      if (!once(slider, 'Slider')) return;
      var track = $('[data-mm-track]', slider);
      if (!track) return;
      var slides = $$('[data-mm-slide]', track);
      var dots = $$('[data-mm-dot]', slider);
      var label = $('[data-mm-active-label]', slider);
      var current = -1;
      var centred = -1; // index in `items` (real slides plus loop clones)

      // Product gallery loops: the last slides peek in on the left of the first one, like Milamend.
      var loop = slides.length > 1 && (slider.hasAttribute('data-mm-loop') || slider.classList.contains('mm-gal__mobile'));
      var items = slides.map(function (el, i) { return { el: el, real: i }; });
      if (loop) {
        var n = Math.min(2, slides.length);
        var before = [], after = [];
        for (var c = 0; c < n; c++) {
          var head = slides[c].cloneNode(true), tail = slides[slides.length - 1 - c].cloneNode(true);
          [head, tail].forEach(function (cl) {
            cl.removeAttribute('data-mm-slide');
            cl.setAttribute('data-mm-clone', '');
            cl.setAttribute('aria-hidden', 'true');
            cl.classList.remove('is-active');
          });
          after.push({ el: head, real: c });
          before.unshift({ el: tail, real: slides.length - 1 - c });
        }
        before.forEach(function (it) { track.insertBefore(it.el, slides[0]); });
        after.forEach(function (it) { track.appendChild(it.el); });
        items = before.concat(items, after);
      }
      function itemOf(real) {
        for (var k = 0; k < items.length; k++) if (items[k].el === slides[real]) return k;
        return 0;
      }

      function centerOf(el) { return el.offsetLeft + el.offsetWidth / 2; }
      function jump(k) { track.scrollLeft = centerOf(items[k].el) - track.clientWidth / 2; }
      function goToItem(k) {
        k = Math.max(0, Math.min(items.length - 1, k));
        track.scrollTo({ left: centerOf(items[k].el) - track.clientWidth / 2, behavior: 'smooth' });
      }
      function goTo(i) { goToItem(itemOf(Math.max(0, Math.min(slides.length - 1, i)))); }
      function update() {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var bestK = 0, bestDist = Infinity;
        items.forEach(function (it, k) {
          var d = Math.abs(centerOf(it.el) - mid);
          if (d < bestDist) { bestDist = d; bestK = k; }
        });
        if (bestK !== centred) {
          centred = bestK;
          items.forEach(function (it, k) { it.el.classList.toggle('is-active', k === bestK); });
        }
        var best = items[bestK].real;
        if (best === current) return;
        current = best;
        slides.forEach(function (el, i) {
          var v = $('video', el);
          if (v && slider.hasAttribute('data-mm-play-active')) {
            if (i === best) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
          }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
        if (label) label.textContent = slides[best].getAttribute('data-mm-name') || '';
      }
      // once a swipe settles on a clone, swap to the real slide without animation
      var settleTimer;
      function settle() {
        if (!loop || centred < 0 || !items[centred].el.hasAttribute('data-mm-clone')) return;
        var k = itemOf(items[centred].real);
        track.style.scrollSnapType = 'none';
        jump(k);
        track.offsetWidth; // flush before restoring snap
        track.style.scrollSnapType = '';
        update();
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 140);
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      var prev = $('[data-mm-prev]', slider), next = $('[data-mm-next]', slider);
      if (prev) prev.addEventListener('click', function () { goToItem(centred - 1); });
      if (next) next.addEventListener('click', function () { goToItem(centred + 1); });
      window.addEventListener('resize', function () {
        if (centred >= 0) jump(itemOf(items[centred].real));
        update();
      });
      var start = parseInt(slider.getAttribute('data-mm-start') || '0', 10);
      if (!slides[start]) start = 0;
      if (start > 0 || loop) jump(itemOf(start));
      update();
    });
  }

  /* ---------- fade carousel (proof card) ---------- */
  function initFades(root) {
    $$('[data-mm-fade]', root).forEach(function (wrap) {
      if (!once(wrap, 'Fade')) return;
      var slides = $$('[data-mm-fade-slide]', wrap);
      var dots = $$('[data-mm-dot]', wrap);
      if (!slides.length) return;
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function auto() {
        clearInterval(timer);
        if (slides.length > 1) timer = setInterval(function () { show(i + 1); }, 4500);
      }
      var prev = $('[data-mm-prev]', wrap), next = $('[data-mm-next]', wrap);
      if (prev) prev.addEventListener('click', function () { show(i - 1); auto(); });
      if (next) next.addEventListener('click', function () { show(i + 1); auto(); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); auto(); }); });
      show(0);
      auto();
    });
  }

  /* ---------- modals + lightbox ---------- */
  function openModal(modal) {
    modal.classList.add('is-open');
    document.documentElement.classList.add('mm-lock');
  }
  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('mm-lock');
    var v = $('video', modal);
    if (v) v.pause();
  }
  function initModals(root) {
    $$('[data-mm-modal-open]', root).forEach(function (btn) {
      if (!once(btn, 'Modal')) return;
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.getAttribute('data-mm-modal-open'));
        if (modal) openModal(modal);
      });
    });
    $$('[data-mm-modal]', root).forEach(function (modal) {
      if (!once(modal, 'ModalEl')) return;
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-mm-modal-close]') || !e.target.closest('[data-mm-modal-card]')) closeModal(modal);
      });
    });
  }
  function initLightbox(root) {
    $$('[data-mm-lightbox]', root).forEach(function (modal) {
      if (!once(modal, 'Lb')) return;
      var scope = modal.closest('[data-mm-product]') || document;
      var all = $$('[data-mm-lb]', scope);
      // mobile and desktop galleries render the same media twice: de-duplicate by index
      var seen = {}, items = [];
      all.forEach(function (el) {
        var k = el.getAttribute('data-mm-lb');
        if (!seen[k]) { seen[k] = true; items.push(el); }
      });
      var img = $('[data-mm-lb-img]', modal);
      var vid = $('[data-mm-lb-video]', modal);
      var dotsWrap = $('[data-mm-lb-dots]', modal);
      var idx = 0;
      if (dotsWrap) {
        dotsWrap.innerHTML = items.map(function () { return '<span class="mm-dot"></span>'; }).join('');
      }
      function show(n) {
        if (!items.length) return;
        idx = (n + items.length) % items.length;
        var el = items[idx];
        var isVideo = el.getAttribute('data-mm-lb-type') === 'video';
        vid.pause();
        if (isVideo) {
          vid.src = el.getAttribute('data-mm-lb-src');
          vid.hidden = false; img.hidden = true;
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
        } else {
          img.src = el.getAttribute('data-mm-lb-src');
          img.alt = el.getAttribute('data-mm-lb-alt') || '';
          img.hidden = false; vid.hidden = true;
        }
        if (dotsWrap) $$('.mm-dot', dotsWrap).forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
      }
      all.forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          var k = el.getAttribute('data-mm-lb');
          var n = 0;
          items.forEach(function (it, i) { if (it.getAttribute('data-mm-lb') === k) n = i; });
          show(n);
          openModal(modal);
        });
      });
      var prev = $('[data-mm-lb-prev]', modal), next = $('[data-mm-lb-next]', modal);
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeModal(modal);
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    });
  }

  /* ---------- product form ---------- */
  function initProduct(root) {
    $$('[data-mm-product]', root).forEach(function (el) {
      if (!once(el, 'Product')) return;
      var form = $('[data-mm-form]', el);
      var dataEl = $('[data-mm-variants]', el);
      if (!form || !dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var moneyFormat = el.getAttribute('data-money-format') || '${{amount}}';
      var servings = parseFloat(el.getAttribute('data-servings') || '0');
      var servingLabel = el.getAttribute('data-serving-label') || '';
      var txt = {
        add: el.getAttribute('data-text-add') || 'Add to cart',
        soldOut: el.getAttribute('data-text-soldout') || 'Sold out',
        unavailable: el.getAttribute('data-text-unavailable') || 'Unavailable',
        adding: el.getAttribute('data-text-adding') || '...',
        save: el.getAttribute('data-text-save') || 'Save'
      };
      var idInput = $('input[name="id"]', form);
      var planInput = $('input[name="selling_plan"]', form);
      var submit = $('[data-mm-submit]', form);
      var submitLabel = $('[data-mm-submit-label]', form);
      var errorEl = $('[data-mm-error]', form);
      var optionGroups = $$('[data-mm-option]', form);

      function selectedOptions() {
        return optionGroups.map(function (g) {
          var c = $('input:checked', g);
          return c ? c.value : null;
        });
      }
      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function currentVariant() {
        if (!optionGroups.length) {
          for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(idInput.value)) return variants[i];
          return variants[0];
        }
        return findVariant(selectedOptions());
      }
      function perServing(cents) {
        if (!servings || !cents) return '';
        return '(' + formatMoney(Math.round(cents / servings), moneyFormat) + servingLabel + ')';
      }
      function setPrice(card, price, compare) {
        var p = $('[data-mm-price]', card), c = $('[data-mm-compare]', card);
        var s = $('[data-mm-per-serving]', card), b = $('[data-mm-save]', card);
        if (p) p.textContent = formatMoney(price, moneyFormat);
        if (c) {
          if (compare && compare > price) { c.textContent = formatMoney(compare, moneyFormat); c.hidden = false; }
          else { c.hidden = true; }
        }
        if (s) { var t = perServing(price); s.textContent = t; s.hidden = !t; }
        if (b) {
          if (compare && compare > price) {
            b.textContent = txt.save + ' ' + Math.round((1 - price / compare) * 100) + '%';
            b.hidden = false;
          } else { b.hidden = true; }
        }
      }
      function updateSoldOut() {
        var sel = selectedOptions();
        optionGroups.forEach(function (g, gi) {
          $$('input', g).forEach(function (input) {
            var opts = sel.slice(); opts[gi] = input.value;
            var v = findVariant(opts);
            var label = input.closest('label');
            if (label) label.classList.toggle('is-soldout', !v || !v.available);
          });
        });
      }
      function update() {
        var v = currentVariant();
        updateSoldOut();
        if (!v) {
          submit.disabled = true;
          submitLabel.textContent = txt.unavailable;
          return;
        }
        idInput.value = v.id;
        submit.disabled = !v.available;
        submitLabel.textContent = v.available ? txt.add : txt.soldOut;

        var allocs = v.selling_plan_allocations || [];
        $$('[data-mm-plan]', form).forEach(function (card) {
          var pid = card.getAttribute('data-mm-plan');
          if (pid === 'onetime') { setPrice(card, v.price, v.compare_at_price); return; }
          var a = null;
          allocs.forEach(function (x) { if (String(x.selling_plan_id) === pid) a = x; });
          card.hidden = !a;
          if (a) setPrice(card, a.price, a.compare_at_price || v.price);
        });
        $$('[data-mm-onetime-price]', el).forEach(function (n) { n.textContent = formatMoney(v.price, moneyFormat); });

        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      optionGroups.forEach(function (g) { g.addEventListener('change', update); });

      $$('[data-mm-plan] input[type="radio"]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          var pid = r.closest('[data-mm-plan]').getAttribute('data-mm-plan');
          if (planInput) planInput.value = pid === 'onetime' ? '' : pid;
        });
      });
      var buyOnce = $('[data-mm-buy-once]', el);
      if (buyOnce) {
        buyOnce.addEventListener('click', function () {
          if (planInput) planInput.value = '';
          $$('[data-mm-plan] input[type="radio"]', form).forEach(function (r) { r.checked = false; });
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submit.disabled) return;
        var original = submitLabel.textContent;
        submit.disabled = true;
        submitLabel.textContent = txt.adding;
        if (errorEl) errorEl.hidden = true;
        var body = new FormData(form);
        if (planInput && !planInput.value) body.delete('selling_plan');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.json.description || res.json.message || 'Error');
            window.location.href = form.getAttribute('data-cart-url') || (root + 'cart');
          })
          .catch(function (err) {
            submit.disabled = false;
            submitLabel.textContent = original;
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });

      update();
    });
  }

  /* ---------- journey timeline ---------- */
  function initJourney(root) {
    $$('[data-mm-journey]', root).forEach(function (el) {
      if (!once(el, 'Journey')) return;
      var items = $$('[data-mm-stage]', el);
      var fill = $('[data-mm-progress]', el);
      function setFill() {
        var active = $('[data-mm-stage].is-open', el);
        if (!fill) return;
        fill.style.height = active ? (active.offsetTop + 16) + 'px' : '0px';
      }
      items.forEach(function (item) {
        var btn = $('[data-mm-stage-btn]', item);
        btn.addEventListener('click', function () {
          items.forEach(function (o) { o.classList.toggle('is-open', o === item); });
          setFill();
          setTimeout(setFill, 450);
        });
      });
      setFill();
      window.addEventListener('resize', setFill);
    });
  }

  /* ---------- reviews ---------- */
  function initReviews(root) {
    $$('[data-mm-reviews]', root).forEach(function (el) {
      if (!once(el, 'Reviews')) return;
      var list = $('[data-mm-reviews-list]', el);
      if (!list) return;
      var all = $$('[data-mm-review]', list);
      var page = parseInt(el.getAttribute('data-page-size') || '3', 10);
      var shown = page, sort = 'latest', filter = 0;
      var more = $('[data-mm-reviews-more]', el);
      var count = $('[data-mm-reviews-count]', el);
      var sortLabel = $('[data-mm-sort-label]', el);
      var dropdown = $('[data-mm-sort-dropdown]', el);
      var countTpl = el.getAttribute('data-count-template') || '{shown} / {total}';

      function render() {
        var rows = all.filter(function (r) { return !filter || parseInt(r.getAttribute('data-rating'), 10) === filter; });
        rows.sort(function (a, b) {
          var ra = parseFloat(a.getAttribute('data-rating')), rb = parseFloat(b.getAttribute('data-rating'));
          var ia = parseInt(a.getAttribute('data-index'), 10), ib = parseInt(b.getAttribute('data-index'), 10);
          if (sort === 'highest') return rb - ra || ia - ib;
          if (sort === 'lowest') return ra - rb || ia - ib;
          if (sort === 'oldest') return ib - ia;
          return ia - ib;
        });
        all.forEach(function (r) { r.hidden = true; });
        rows.forEach(function (r, i) { list.appendChild(r); r.hidden = i >= shown; });
        if (more) more.hidden = rows.length <= shown;
        if (count) {
          count.textContent = countTpl
            .replace('{shown}', Math.min(shown, rows.length))
            .replace('{total}', rows.length);
        }
      }
      if (more) more.addEventListener('click', function () { shown += page; render(); });
      $$('[data-mm-star-filter]', el).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(b.getAttribute('data-mm-star-filter'), 10);
          filter = filter === n ? 0 : n;
          $$('[data-mm-star-filter]', el).forEach(function (o) {
            o.classList.toggle('is-active', filter && parseInt(o.getAttribute('data-mm-star-filter'), 10) === filter);
          });
          shown = page;
          render();
        });
      });
      var toggle = $('[data-mm-sort-toggle]', el);
      if (toggle && dropdown) {
        toggle.addEventListener('click', function (e) { e.stopPropagation(); dropdown.hidden = !dropdown.hidden; });
        document.addEventListener('click', function () { dropdown.hidden = true; });
        $$('[data-mm-sort]', dropdown).forEach(function (b) {
          b.addEventListener('click', function () {
            sort = b.getAttribute('data-mm-sort');
            if (sortLabel) sortLabel.textContent = b.textContent;
            shown = page;
            render();
          });
        });
      }
      render();
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = $$('[data-mm-reveal]', root).filter(function (el) { return once(el, 'Reveal'); });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) {
    root = root || document;
    initAccordions(root);
    initSliders(root);
    initFades(root);
    initModals(root);
    initLightbox(root);
    initProduct(root);
    initJourney(root);
    initReviews(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();